import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import theme from "../../theme";
import { adjustColorBrightness } from "../../theme/colors";

export const StyledButton = styled(Button)(
  ({ bordercolor, backgroundcolor, textcolor, variant }) => ({
    borderColor: bordercolor,
    backgroundColor: `${backgroundcolor} !important`,
    color: `${textcolor} !important`,
    textTransform: "none",
    ":hover": {
      filter:
        backgroundcolor === theme.colors.white
          ? "brightness(1)"
          : "brightness(0.85)",
      borderColor:
        variant === "outlined" && bordercolor
          ? adjustColorBrightness(bordercolor, -15)
          : bordercolor,
    },
  })
);

StyledButton.propTypes = {
  variant: PropTypes.string.isRequired,
  bordercolor: PropTypes.string.isRequired,
  backgroundcolor: PropTypes.string.isRequired,
  textcolor: PropTypes.string.isRequired,
};

export default StyledButton;
